import React from 'react';
export function Footer() {
  return <footer className="bg-dark-DEFAULT border-t border-dark-border py-12 px-4" data-id="element-88">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8" data-id="element-89">
        <div className="text-center md:text-left max-w-sm" data-id="element-90">
          <h3 className="text-3xl font-bebas text-brand-DEFAULT mb-2 tracking-wider" data-id="element-91">
            🏐 EDULABS™
          </h3>
          <p className="text-text-secondary text-sm leading-relaxed" data-id="element-92">
            El sistema de entrenamiento N°1 para entrenadores de vóley. Porque
            entrenar vóley no debería costarte todas las noches de la semana.
          </p>
        </div>

        <div className="text-center md:text-right text-sm text-text-secondary space-y-2" data-id="element-93">
          <p data-id="element-94">
            Email:{' '}
            <a href="mailto:soporte.edulabs@gmail.com" className="text-brand-DEFAULT hover:underline" data-id="element-95">
              soporte.edulabs@gmail.com
            </a>
          </p>
          <p data-id="element-96">
            Instagram:{' '}
            <a href="#" className="text-brand-DEFAULT hover:underline" data-id="element-97">
              @edulabs.oficial
            </a>
          </p>
          <p data-id="element-98">
            Web:{' '}
            <a href="#" className="text-brand-DEFAULT hover:underline" data-id="element-99">
              www.edulabs.online
            </a>
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-dark-border text-center text-xs text-text-secondary" data-id="element-100">
        <p data-id="element-101">
          © EDULABS™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}